module.exports = __webpack_public_path__ + "static/media/DSCF0032.770e61ae.jpg";